'use client';

import { DepositModal } from '../auth/DepositModal';
import { AuthModal } from '../auth/subcomponents/modal/AuthModal';
import { HowItWorksModal } from '../onboarding/HowItWorksModal';
import { InviteGateModal } from '../referrals/InviteGateModal';
import { SearchDropdown } from '../search/Dropdown/SearchDropdown';
import { PositionActionModal } from './PositionActionModal';

interface ModalsOrchestratorProps {
  auth: {
    isOpen: boolean;
    onClose: () => void;
  };
  deposit: {
    isOpen: boolean;
    onClose: () => void;
  };
  howItWorks: {
    isOpen: boolean;
    onClose: () => void;
  };
  search: {
    isOpen: boolean;
    onClose: () => void;
    anchorRef: React.RefObject<HTMLDivElement | null>;
    searchQuery?: string;
  };
  referral: {
    isOpen: boolean;
    onClose: () => void;
  };
}

export const ModalsOrchestrator = ({
  auth,
  deposit,
  howItWorks,
  referral,
  search,
}: ModalsOrchestratorProps) => {
  return (
    <>
      <AuthModal isOpen={auth.isOpen} onClose={auth.onClose} />
      <DepositModal isOpen={deposit.isOpen} onClose={deposit.onClose} />
      <HowItWorksModal isOpen={howItWorks.isOpen} onClose={howItWorks.onClose} />
      <PositionActionModal />

      <SearchDropdown
        isOpen={search.isOpen}
        onClose={search.onClose}
        anchorRef={search.anchorRef}
        searchQuery={search.searchQuery}
      />

      <InviteGateModal isOpen={referral.isOpen} onClose={referral.onClose} />
    </>
  );
};
